import React, { useState, useContext } from "react";
import "./reportReviewModal.css";
import { CombinedContext } from "../../context/combinedContext";
import usersRequest from "../../request/usersRequest";

const ReportReviewModalAdmin = ({ open, onClose, reviewId, shopId }) => {
	const { language, userData } = useContext(CombinedContext);

	const [details, setDetails] = useState("");
	const [loading, setLoading] = useState(false);
	const [toast, setToast] = useState("");

	if (!open) return null;

	async function submitReport() {
		try {
			setLoading(true);
	
			await usersRequest.flagReview(shopId, reviewId, {
				reason: "Reported by shop/admin",
				message: details,
				email: userData?.user?.email || null,
			});
	
			setToast(language === "es" ? "Reporte enviado." : "Report submitted.");
	
			setTimeout(() => {
				onClose();
			}, 800);
		} catch (err) {
			console.error("Failed to report review:", err);
			setToast(
				language === "es"
					? "No se pudo enviar el reporte."
					: "Failed to submit report."
			);
		} finally {
			setLoading(false);
		}
	}
	return (
		<div className="sf-report-overlay" onClick={onClose}>
			<div className="sf-report-modal" onClick={(e) => e.stopPropagation()}>
				{/* HEADER */}
				<div className="sf-report-header">
					<h3 className="sf-report-title">
						{language === "es" ? "Reportar Reseña" : "Report Review"}
					</h3>

					<button className="sf-report-close" onClick={onClose}>
						✕
					</button>
				</div>

				{/* BODY */}
				<div className="sf-report-body">
					<p className="sf-report-subtitle">
						{language === "es"
							? "Describe por qué estás reportando esta reseña (opcional)."
							: "Describe why you are reporting this review (optional)."}
					</p>

					<textarea
						className="sf-report-textarea"
						placeholder={
							language === "es"
								? "Detalles adicionales (opcional)"
								: "Additional details (optional)"
						}
						value={details}
						onChange={(e) => setDetails(e.target.value)}
					/>
				</div>

				{/* FOOTER */}
				<div className="sf-report-footer">
					<button className="sf-report-btn-cancel" onClick={onClose}>
						{language === "es" ? "Cancelar" : "Cancel"}
					</button>

					<button
						className="sf-report-btn-submit"
						onClick={submitReport}
						disabled={loading}
					>
						{loading
							? language === "es"
								? "Enviando..."
								: "Submitting..."
							: language === "es"
							? "Enviar Reporte"
							: "Submit Report"}
					</button>
				</div>

				{toast && <div className="sf-report-toast">{toast}</div>}
			</div>
		</div>
	);
};

export default ReportReviewModalAdmin;
